/**
 * Espelho da allowlist de src/consoleai/attachment_service.py linhas 28-32.
 * ATUALIZAR EM PAR: ao mudar uma lista, atualizar a outra também.
 *
 * Backend aceita: image/*, application/pdf, text/*, application/zip,
 * application/gzip, application/octet-stream (com warning), e bloqueia
 * extensões: .exe .sh .bat .dll .msi .js .html .cmd .ps1
 */
export const ALLOWED_MIME_PREFIXES = [
  'image/',
  'application/pdf',
  'text/',
  'application/zip',
  'application/gzip',
] as const

export const BLOCKED_EXTENSIONS = [
  '.exe', '.sh', '.bat', '.dll', '.msi', '.js', '.html', '.cmd', '.ps1',
] as const

export const MAX_ATTACHMENT_SIZE_BYTES = 52_428_800 // 50 MB

export function isMimeAllowed(mimeType: string): boolean {
  return ALLOWED_MIME_PREFIXES.some((prefix) => mimeType.startsWith(prefix))
}

export function isExtensionBlocked(filename: string): boolean {
  const lower = filename.toLowerCase()
  return BLOCKED_EXTENSIONS.some((ext) => lower.endsWith(ext))
}

/**
 * Valida arquivo antes de adicionar ao buffer.
 * Retorna mensagem de erro ou null se válido.
 */
export function validateFile(file: File): string | null {
  if (file.size > MAX_ATTACHMENT_SIZE_BYTES) {
    return `Arquivo excede o limite de 50MB (${(file.size / 1024 / 1024).toFixed(1)}MB)`
  }
  if (file.size <= 0) {
    return 'Arquivo vazio'
  }
  if (isExtensionBlocked(file.name)) {
    return `Extensão bloqueada: ${file.name.split('.').pop()}`
  }
  if (!isMimeAllowed(file.type) && file.type !== 'application/octet-stream') {
    return `Tipo não permitido: ${file.type || 'desconhecido'}`
  }
  return null
}
